export default __webpack_public_path__ + "static/media/fpx-logo.2b37c4b5.svg";